import { Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { Txt } from '@app/components/common';

import { ActionDialogProps } from './types';

export const ApproveDialog = ({ onAction, selectedTx, actionName }: ActionDialogProps) => {
  const [open, setOpen] = useState(false);
  return <>
    <Button colorScheme='green' onClick={() => setOpen(true)} >{actionName}</Button>
    <Dialog
      open={open}
      title="Согласовать транзакцию"
      onClose={() => setOpen(false)}
      actions={[
        <Button variant='solid' colorScheme='green' key='cancel' onClick={() => {
          onAction(selectedTx);
          setOpen(false);
        }} >Подтвердить</Button>
      ]}
    >
      <Flex>
        <Txt>Согласовать перемещение ХО?</Txt>
      </Flex>
    </Dialog>
  </>;
};